import {ICmsContent} from './cms.controller';

export class CmsEditorDialog {
  static $inject = ['$mdDialog'];

  private cmsContent: ICmsContent[];

  constructor(private $mdDialog:ng.material.IDialogService) {

  }

  apply = () => {
    this.$mdDialog.hide(this.cmsContent);
  };

  cancel = () => {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/cms/cms-editor-dialog.controller.ts
 **/